import axios from "axios";
import { BASE_URL } from "../../constant";

import { handleFormatResponse, handleFormatResponseForError } from '../../utility';
import { ITeacherToClassAllocation, ITeacherToClassAllocationUpdate } from '../../../../types';

export function useSchoolData() {

    const fetchSchoolData = async (
        endpoint: string
    ) => {
        try {

            let response = await axios.get(`${BASE_URL}School${endpoint}`);
            // console.log("Response: ", response?.data);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;

        } catch (error: any) {

            // console.log("Error: ", error);
            const formattedError = handleFormatResponseForError(error);
            return formattedError;

        }
    };

    const postSchoolData = async (
        endpoint: string,
        payload: ITeacherToClassAllocation
    ) => {
        try {

            let response = await axios.post(`${BASE_URL}School${endpoint}`, payload);
            // console.log("Response: ", response?.data);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;

        } catch (error: any) {

            // console.log("Error: ", error);
            const formattedError = handleFormatResponseForError(error);
            return formattedError;

        }
    };

    const putSchoolData = async (
        endpoint: string,
        payload: ITeacherToClassAllocationUpdate
    ) => {
        try {

            let response = await axios.put(`${BASE_URL}School${endpoint}`, payload);
            // console.log("Response: ", response?.data);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;

        } catch (error: any) {

            // console.log("Error: ", error);
            const formattedError = handleFormatResponseForError(error);
            return formattedError;

        };
    };

    const deleteSchoolData = async (
        endpoint: string
    ) => {
        try {

            let response = await axios.delete(`${BASE_URL}School${endpoint}`);
            // console.log("Response: ", response?.data);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;

        } catch (error: any) {

            // console.log("Error: ", error);
            const formattedError = handleFormatResponseForError(error);
            return formattedError;

        };
    };

    return {
        fetchSchoolData,
        postSchoolData,
        putSchoolData,
        deleteSchoolData
    };
}
